import {
    type ReactNode,
    Fragment
} from "react";
import {
    type DialogContextType,
    type DialogDataType
} from "../types/dialog";
import NCoreContext, {
    type ConfigType
} from "ncore-context";
import {
    uuid
} from "../utils";
import Dialog from "../components/dialog";

class NCoreUIKitDialog extends NCoreContext<DialogContextType, ConfigType<DialogContextType>> {
    constructor({
        data = []
    }: {
        data?: Array<DialogDataType>
    }) {
        super({
            close: () => {},
            open: () => "",
            data: data
        }, {
            key: "NCoreUIKit-DialogContext"
        });
    };

    open = (dialogData: DialogDataType) => {
        const currentData = this.state.data;

        const dialogID = dialogData.id ? dialogData.id : uuid();

        currentData.push({
            ...dialogData,
            id: dialogID
        });

        this.setState({
            data: currentData
        });

        return dialogID;
    };

    close = (props?: {
        index?: number;
        id?: string;
    }) => {
        const currentData = this.state.data;

        if (props && props.id) {
            const keyIndex = currentData.findIndex((dialog) => dialog.id === props.id);

            if (keyIndex !== -1) {
                currentData.splice(keyIndex, 1);

                this.setState({
                    data: currentData
                });
            }

            return;
        }

        if (props && props.index !== undefined) {
            currentData.splice(props.index, 1);

            this.setState({
                data: currentData
            });

            return;
        }

        currentData.pop();

        this.setState({
            data: currentData
        });
    };

    Render = ({
        children
    }: {
        children: ReactNode;
    }) => {
        const {
            data
        } = this.useContext();

        return <Fragment>
            {children}
            {data.map((item: DialogDataType) => {
                return <Dialog
                    onClosed={() => {
                        if(item.onClosed) {
                            item.onClosed({
                                id: item.id as string
                            });
                        }

                        if(item.isAutoClosed === undefined || item.isAutoClosed === true) {
                            this.close({
                                id: item.id
                            });
                        }
                    }}
                    key={`NCoreUIKit-Dialog-${item.id}`}
                    id={item.id as string}
                    {...item}
                />;
            })}
        </Fragment>;
    };
}
export default NCoreUIKitDialog;
